module.exports = "/_next/static/images/6e677b171badf4138df3633ea939f11b-card-background-left-xs.jpg";